import axios from 'axios';
import 'axios-response-logger';
import extend from 'lodash/extend';

import {BglMonitor, BglMonitorEvent, BglUserAgentHeaders} from '@bgl/lib-ts-integration';

export const URL_FETCH_SIMULATION = '/business_public_feesim/rest/v1/card/payment/calculate/fees';

axios.interceptors.request.use(request => {

    extend(request.headers, BglUserAgentHeaders.generateHeaders().getHeaders());
    extend(request.headers, BglMonitor.getInstance().setMonitoringDefaultContext().getHeaders());

    const url = request.url;
    const path = request.headers[BglMonitor.BGL_MONITORING_PATH_HEADER_KEY.toLowerCase()];
    const propagationId = request.headers[BglMonitor.BGL_MONITORING_PROPAGATION_ID_HEADER_KEY.toLowerCase()];

    BglMonitor.getInstance().registerEvent(BglMonitorEvent.createStartEvent(url, path, propagationId));

    return request;
});

axios.interceptors.response.use(response => {
    const path = response.config.headers[BglMonitor.BGL_MONITORING_PATH_HEADER_KEY.toLowerCase()];
    const propagationId = response.config.headers[BglMonitor.BGL_MONITORING_PROPAGATION_ID_HEADER_KEY.toLowerCase()];

    BglMonitor.getInstance().registerEvent(BglMonitorEvent.createEndEvent(path, propagationId));

    return response;
});

export const getSimulation = (paymentAmount, cardType, paymentCurrency) => {
    const payload = {
        paymentAmount,
        cardType,
        paymentCurrency
    };

    return axios.post(URL_FETCH_SIMULATION, payload).then(response => response.data);
};
